import React from "react";
import PropTypes from "prop-types";

import ImagePreventRightClick from "core/ImagePreventRightClick";

import { IconGridItemContainer, AnchorLink, RouterLink } from "./styles";

const IconGridItem = ({
    iconId,
    iconTitle,
    iconPreviewUrl,
    iconDetailPermalink,
    useRouterLink
}) => {
    const LinkComponent = useRouterLink ? RouterLink : AnchorLink;
    const linkProps = {
        [useRouterLink ? "to" : "href"]: iconDetailPermalink
    };
    return (
        <LinkComponent {...linkProps}>
            <IconGridItemContainer>
                <ImagePreventRightClick
                    imageSrc={iconPreviewUrl}
                    srText={`${iconTitle} Icon ${iconId}`}
                />
            </IconGridItemContainer>
        </LinkComponent>
    );
};

IconGridItem.propTypes = {
    iconId: PropTypes.string.isRequired,
    iconTitle: PropTypes.string.isRequired,
    iconPreviewUrl: PropTypes.string.isRequired,
    iconDetailPermalink: PropTypes.string.isRequired
};

export default IconGridItem;
